/**
 * Route Types are used by application to handle routing internally, externally, or
 * some custom action like opening a modal dialog
 */
export enum RouteTypes {
  INTERNAL = 'internal', // Internal route types are used for routing within the application
  EXTERNAL = 'external', // External routes types can be external links outside of application and email
  LOGIN = 'login', // Special internal route type used for routing to the login page
  MODAL = 'modal', // Modal route types will call a modal dialog within the application
  DISABLED = 'disabled', // Disabled button used to disable course sessions, if one course session has been enroled
  LINK = 'link', // Used to handle click events for a specific link that is usually a internal route. Use this sparingly.
  SUBSCRIPTION = 'subscription', // Used to handle internal route type that are subscription links. Use this sparingly.
  MAILTO = 'mailto', // Use to handle email mailto link to open user's email client
}
